import React from 'react';
import { SectionShell } from './SectionShell';
import { ConfirmNote } from './ConfirmNote';
import { rangeProjects } from '../data/caseStudy';
export function Range() {
  return <SectionShell number="08" title="Range" tone="grey" eyebrow="My work extended beyond the CreateFuture brand, leading the visual direction for external campaigns with distinct identities tailored to different audiences and objectives." data-id="element-80" data-mp="2gzrap5ktqggi">
      <div className="grid grid-cols-2 gap-8" data-id="element-81" data-mp="1ocws6e7khr5o">
        {rangeProjects.map(project => <article key={project.title} className="flex flex-col bg-white p-10" style={{
        width: "1005px"
      }} data-id="element-82" data-mp="1tag9jmzkak1u">
            <p className="font-display text-[11px] font-semibold uppercase tracking-[0.24em] text-accent-purple" data-id="element-83" data-mp="1y76mw2jzf1jk">
              {project.kicker}
            </p>
            <h3 className="mt-4 font-display text-3xl font-semibold tracking-tightest text-ink" data-id="element-84" data-mp="15jj8x6d7v95w">
              {project.title}
            </h3>
            <p className="mt-5 flex-1 text-[15px] leading-relaxed text-ink/70" data-id="element-85" data-mp="1ahksdsek1ahw">{project.body}</p>
            <div className="mt-8 border-t border-ink/10 pt-7" data-id="element-86" data-mp="22a1b3bdi0e80">
              <p className="font-display text-[52px] font-bold leading-none tracking-tightest text-ink" data-id="element-87" data-mp="1xa6nphsxm6rp">
                {project.stat}
              </p>
              <p className="mt-3 text-sm leading-snug text-ink/60" data-id="element-88" data-mp="1nj27yfvfmhvt">{project.statLabel}</p>
            </div>
            {project.note ? <div className="mt-7" data-id="element-89" data-mp="1jhqs322d1b0t">
                <ConfirmNote data-id="element-90" data-mp="1jis3j7nafzj2">{project.note}</ConfirmNote>
              </div> : null}
          </article>)}
      </div>

      <div className="mt-12" data-id="element-91" data-mp="1ekqjoki1fw6j">
        <h3 className="font-display text-[11px] font-semibold uppercase tracking-[0.24em] text-ink/50" data-id="element-92" data-mp="19irh3cu4h3an">
          Catalyst24, selected work
        </h3>
        <div className="mt-6 grid grid-cols-2 gap-8" data-id="element-93" data-mp="14masyimxaoxk">
          <figure data-id="element-94" data-mp="33xkbj8j9ro10">
            <img src="https://cdn.magicpatterns.com/uploads/wdZ3TK8GacUt7cTB6xECSo/Nektaria_Bogris_2025_projects6.png" alt="Catalyst24 event environment: exhibition stand and agenda panels alongside the responsive conference site" className="w-full border border-ink/10 object-cover" data-id="element-95" data-mp="33w0wfl9cnj0t" />
            <figcaption className="mt-4 text-sm text-ink/55" data-id="element-96" data-mp="121l3kk9g9ry8">
              Event environment and the responsive site built in ReadyMag.
            </figcaption>
          </figure>
          <figure data-id="element-97" data-mp="sa8hyae8vy0n">
            <img src="https://cdn.magicpatterns.com/uploads/77ViGB97eXMi7VL6DVP4vo/Nektaria_Bogris_2025_projects7.png" alt="Catalyst24 identity applied across four colourways, including the logo lockup, event details and the Social Bite partner mark" className="w-full border border-ink/10 object-cover" data-id="element-98" data-mp="1fzjjhu3f5wfu" />
            <figcaption className="mt-4 text-sm text-ink/55" data-id="element-99" data-mp="1ayvhkddnjv6u">
              Identity system and lockups across the full colourway range.
            </figcaption>
          </figure>
        </div>
      </div>
    </SectionShell>;
}